export const faultCategoryDictionary = {
    1: 'Critical condition',
    2: 'Warning',
    3: 'Information'
}

//TODO: wlasciwy slownik
/*export const faultCategoryDictionary = {
    '': 'Choose fault category',
    1: 'Fundamenty',
    2: 'Uziemienie',
    3: 'Konstrukcja wsporcza słup',
    4: 'Izolacja',
    5: 'Łączniki',
    6: 'Ograniczniki przepięć',    
    7: 'Głowice kablowe',
    8: 'Przewody robocze',
    9: 'Przewody odgromowe',
    10: 'Trasa linii (skrzyżowania)',
    11: 'Budynki stacji'
}*/

/*
export const faultTypeDictionary = {
    '': 'Choose fault type',

    101: 'Zalewisko',
    102: 'Nadmiar ziemi',
    103: 'Niedomiar ziemi',
    104: 'Drzewa, krzewy',
    105: 'Uszkodzenie betonu',
    106: 'Inne',

    201: 'Korozja',
    202: 'Zerwane/odkręcone śruby',
    203: 'Odkryty otok',
    204: 'Inne',

    301: 'Korozja - punktowa',
    302: 'Korozja - powierzchniowa',
    303: 'Uszkodzenie połączenia stopy z fundamentem',
    304: 'Kątownik - brak',
    305: 'kątownik, konstrukcja - uszkodzenie',
    306: 'Podest transformatorowy - uszkodzenie',
    307: 'Połączenie elementów słupa',
    308: 'Tabliczka ostrzegawcza - brak / nieczytelna / nieaktualna',
    309: 'Tabliczka fazowa - brak / nieczytelna / nieaktualna',
    310: 'Tabliczka torowa - brak / nieczytelna / nieaktualna',
    311: 'Brak oznakowania słupów',
    312: 'Pochylenie słupa',
    313: 'Uszkodzenie betonu',
    314: 'Pęknięcie / złamanie żerdzi',
    315: 'Spróchniała żerdź',
    316: 'Brak / uszkodzona osłona wierzchołka słupa',
    317: 'Nieczynny osprzęt',
    318: 'Obce elementy - gniazdo',
    319: 'Obce elementy - reklama',
    320: 'Obce elementy - inne',
    321: 'Inne',

    401: 'Izolator - zerwany',
    402: 'Izolator - uszkodzony',
    403: 'Izolator - zabrudzony',
    404: 'Izolator - wychylony',
    405: 'Obostrzenie - brak/nieprawidłowe',
    406: 'Osłony przeciw ptakom - brak/zły stan',
    407: 'Wiązałka - zły stan',
    408: 'Inne',

    501: 'Izolator - uszkodzony',
    502: 'Izolator - zabrudzony',
    503: 'Stan napędu',
    504: 'Tabliczka numeracyjna - brak/nieczytelna',
    505: 'Termowizja - podwyższona temperatura - łącznik',
    506: 'Inne',

    601: 'Ogranicznik - uszkodzony',
    602: 'Ogranicznik - zabrudzony',
    603: 'Brak uziemienia ogranicznika',
    604: 'Termowizja - podwyższona temperatura - głowica',
    605: 'Inne',

    701: 'Głowica - uszkodzona',
    702: 'Głowica - zabrudzona',
    703: 'Stan konstrukcji i osłon kabl. (rury)',
    704: 'Stan uszczelnienia osłon kabl.',
    705: 'Brak uziemienia żyły powrotnej',
    706: 'Termowizja - podwyższona temperatura - głowica',
    707: 'Inne',

    801: 'Rozmietlenie/ popękane druty',
    802: 'Uszkodzenie izolacji przewodu',
    803: 'Stan mostka roboczego',
    804: 'Przeprężenie przewodów',
    805: 'Złączka - ilość >1',
    806: 'Złączka - nieprawidłowa',
    807: 'Obiekty obce',
    808: 'Drzewa, krzewy',
    809: 'Termowizja - podwyższona temperatura - zacisk',
    810: 'Termowizja - podwyższona temperatura - złączka',
    811: 'Termowizja - podwyższona temperatura - zacisk nN transf',
    812: 'Termowizja - podwyższona temperatura - zacisk SN transf',
    813: 'Termowizja - podwyższona temperatura - inne',
    814: 'Inne',
    
    901: 'Rozmietlenie, popękane druty',
    902: 'Stan mostka odgromowego',
    903: 'Brak przewodu odgromowego',
    904: 'Przeprężenie przewodów',
    905: 'Obiekty obce',
    906: 'Drzewa',
    907: 'Termowizja - podwyższona temperatura - zacisk',
    908: 'Inne',

    1001: 'Plac budowy, składowisko',
    1002: 'Miejsce uczęszczane przez ludzi',
    1003: 'Droga utwardzona',
    1004: 'Linia energetyczna',
    1005: 'Inne',

    1101: 'Uszkodzony dach',
    1102: 'Uszkodzona elewacja',
    1103: 'Brak dostępu',
    1104: 'Uszkodzony dach'
}*/

export const faultsDictionary = {
    createdByUserId: {
        header: 'Created by (id)',
        isEditable: false,
        renderType: 'text',
        visible: false,
    },
    createdByUserName: {
        header: 'Created by (name)',
        isEditable: false,
        renderType: 'text',
        visible: true,
    },
    createdDateTime: {
        header: 'Created on',
        isEditable: false,
        renderType: 'datetime',
        visible: true,
    },
    description: {
        header: 'Description',
        isEditable: true,
        renderType: 'text',
        visible: true,
    },
    faultCategory: {
        header: 'Fault category',
        isEditable: true,
        renderType: 'select',
        dictionary: faultCategoryDictionary,
        visible: true,
    },
    dateTime: {
        header: 'Date',
        isEditable: true,
        renderType: 'datetime',
        visible: true,
    },
    id: {
        header: 'Id',
        isEditable: false,
        renderType: 'text',
        visible: false,
    },
    modifiedByUserName: {
        header: 'Modified by',
        isEditable: false,
        renderType: 'text',
        visible: true,
    },
    modifiedDateTime: {
        header: 'Modified on',
        isEditable: false,
        renderType: 'datetime',
        visible: true,
    },
    faultTags: {
        header: 'Tags',
        isEditable: false,
        renderType: 'tag',
        visible: false,
    },
    photosCount: {
        header: 'Photos count',
        isEditable: false,
        renderType: 'numeric',
        visible: false,
    },
    videosCount: {
        header: 'Videos count',
        isEditable: false,
        renderType: 'numeric',
        visible: false,
    },
}


// WEBPACK FOOTER //
// ./src/utilities/faultsDictionary.js